import { useMemo } from 'react';
import { renderBroadcastEmailHtmlClient } from '../../../lib/sanitizeHtmlClient';

// Phase 6B Phase D — render AM-authored survey markdown (intro / outro / content
// pages) on the public page. Reuses the shared markdown→DOMPurify-sanitised
// pipeline (the broadcast renderer is the generic sanitised-markdown renderer
// despite the name) so the unauthed surface can never execute injected HTML.
export function SurveyMarkdown({ markdown, className }: { markdown: string; className?: string }) {
  const html = useMemo(() => renderBroadcastEmailHtmlClient(markdown ?? ''), [markdown]);
  if (!markdown?.trim()) return null;
  return (
    <div
      className={'prose prose-sm max-w-none text-slate-700 ' + (className ?? '')}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
